<template>
    <div v-if="widgetSettings && widgetSettings.length > 0" >
        <div class="dashboard-view">
             <div class="container-fluid fixed-top-bar-padding dashboard-wrapper">
                        <div class="dashboard-view-header" style="z-index: 700;" >
                            <div class="media-call-icon">
                                <img :src="require(`@/csmworkflow/img/media-call.svg`)"/>
                            </div>
                            <div class="view-header-title">
                                <span class="listTitle" ><h2 style="font-weight:bold;">Media Call Dashboard</h2></span>
                                <span class="lastUpdate">Last Updated {{lastUpdatedDate  | moment("MMM D,YYYY HH:mm a")}}</span>
                                <span class="offLineMessage">{{isOnLine | offlineMessage}}</span>
                            </div>
                        </div>

                <div class="dashboard-graphs" 
                v-if="widgetSettings[0].json_value.today.visibility" >
                        <div class="dashboard-header">
                                <div class="row">
                                    <div class=" stats-border breakpoint__fix">
                                        <div class="dashboard-stats">
                                            <div class="stats-left-name-wrap" >
                                                <span class="stats-left-name">{{ widgetSettings[0].json_value.today.label }}</span>
                                            </div>
                                             <NumberStat 
                                              v-for="status in widgetSettings[0].json_value.today.columns" 
                                              :key="status.dashboardType" 
                                              :statusData="status" 
                                              />
                                        </div>
                                    </div>
                                </div>
                        </div>
                </div>
                <div class="dashboard-graphs" 
                v-if="widgetSettings[0].json_value.closed.visibility" >
                        <div class="dashboard-header">
                                <div class="row">
                                    <div class=" stats-border breakpoint__fix">
                                        <div class="dashboard-stats" >
                                            <div class="stats-left-name-wrap" >
                                                <span class="stats-left-name">{{ widgetSettings[0].json_value.closed.label }}</span>
                                            </div>
                                            <NumberStat 
                                             v-for="status in widgetSettings[0].json_value.closed.columns" 
                                             :key="status.dashboardType" 
                                             :statusData="status" 
                                             />
                                        </div>
                                    </div>
                                </div>
                        </div>
                </div>
                <div class="dashboard-graphs" 
                v-if="widgetSettings[0].json_value.trending.visibility" >
                      <div class="dashboard-header">
                                <GraphStat 
                                  v-for="status in widgetSettings[0].json_value.trending.columns" 
                                  :key="status.dashboardType" 
                                  :statusData="status" 
                                  />
                        </div>
                </div>
                 <div class="dashboard-graphs" 
                 v-if="widgetSettings[0].json_value.graph.visibility" >
                        <perfect-scrollbar >
                                <GraphStat 
                                  v-for="status in widgetSettings[0].json_value.graph.columns" 
                                  :key="status.dashboardType" 
                                  :statusData="status" 
                                  />
                        </perfect-scrollbar>
                </div>
            </div>
        </div>
        <div class="dashboard-right-list">
             <div class="container-fluid" 
             v-if="widgetSettings[0].json_value.list.visibility" >
                         <DeliverableList  
                          v-for="status in widgetSettings[0].json_value.list.columns" 
                          :key="status.dashboardType" 
                          :statusData="status" 
                          @lastUpdated='lastUpdated' 
                          />
            </div>
        </div>


    </div>



</template>
<script>
import { mapActions, mapGetters } from "vuex";
import DeliverableList from "../components/dashboard/DashboardMediaCallsList"; // Right Side List
import GraphStat from "../components/dashboard/GraphStat"; // Departments Graph
import NumberStat from "../components/dashboard/NumberStat"; // NumberStat Tiles

export default {
    data() {
    return {
    	namespace:"",
      expandAll: !this.isMobile(),
      lastUpdatedDate: new Date(),
      isOnLine:navigator.onLine,
    }
  },
  computed: {
    ...mapGetters([
      "widgetSettings",
    ]),
  },
  filters: {
        offlineMessage: function(isOnline){
            if(!isOnline){
                return "Internet connection is not available.";
            }
        }
    },
  components: {
    DeliverableList,
    NumberStat,
    GraphStat
  },
  methods: {
    ...mapActions([
      "fetchWidgetSettings",
    ]),
    lastUpdated(lastUpdated) {
    this.lastUpdatedDate = lastUpdated;
    },
  },
    beforeDestroy() {
        window.removeEventListener('online', ()=>{this.isOnLine=true});
        window.removeEventListener('offline', ()=>{this.isOnLine=false});
    },
    async created() {
      if (!this.widgetSettings[0]) {
        await this.fetchWidgetSettings();
      }
    },
    async mounted() {
         window.addEventListener('online', ()=>{this.isOnLine=true});
         window.addEventListener('offline', ()=>{this.isOnLine=false});
    }
}
</script>
